import { Container } from '@geberit/gdds';

// styles
import styles from './country-selector.module.scss';

// components
import { CountrySelectorItem, Country } from './country-selector-item';
import { SectionClosingLine } from 'components/ContentElementsGdds/Common/section-closing-line';
import { InlineEdit } from 'components/ContentCreator/InlineEdit';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';
import { useNord } from 'utils/hooks/use-nord';
import { usePreviewIdBuilder } from 'utils/preview-id-builder';

export interface CountrySelectorProps {
  countries: Country[];
  previewId: string;
  type: string;
  isInSubscription: boolean;
  contentIndex: number;
  contentLength: number;
  isChild: boolean;
  border: string;
  titleInAnchor: boolean;
  isContainerChild: boolean;
  isSectionReference: boolean;
}

export function CountrySelector({ countries, border }: Readonly<CountrySelectorProps>) {
  const showClosingLine = border === '';
  const isNord = useNord();
  const borderClass = border === 'disable-border' || isNord ? styles.disableBorder : '';
  const nordWithClosingLine = isNord && showClosingLine;
  const previewIdBuilder = usePreviewIdBuilder();

  return (
    <>
      <Container
        maxContentWidth="80rem"
        className={classNameBuilder(!nordWithClosingLine && styles.countrySelectorWrapper)}
      >
        <section
          className={classNameBuilder(
            styles.countrySelector,
            borderClass,
            showClosingLine && styles.withClosingLine,
          )}
          data-preview-id={previewIdBuilder('#st_countries')}
        >
          {countries.map((country, index) => {
            return (
              <InlineEdit previewId={`#${index}`} key={index}>
                <CountrySelectorItem country={country}/>
              </InlineEdit>
            );
          })}
        </section>
      </Container>
      {nordWithClosingLine && <SectionClosingLine />}
    </>
  );
}
